namespace e5 {
    export class History {

        public onHashChange = Signal.create<[string]>();
        private _hash: string = "";

        constructor() {
            this.init();
        }

        private init(): void {
            this._hash = window.location.hash.substring(1);
            $(window).bind('hashchange', () => this.handleHashChange());
        }

        private handleHashChange(): void {
            var newHash: string = window.location.hash;
            newHash = newHash.substring(1);

            var changed = newHash != this._hash;
            this.setHash(newHash);
            if (changed)
                this.onHashChange.dispatch(this._hash);
        }

        public getHash(): string {
            return this._hash;
        }

        public setHash(value: string): void {
            if (this._hash == value)
                return;
            this._hash = value;
            window.location.hash = "#" + this._hash;
        }

        public clear(): void {
            window.location.hash = null;
        }
    }
}